import React from 'react';
import cn from 'classnames';

import ICON_ARROW from 'assets/images/arrow-down@3x.png';
import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { formatDayToShortYearOrdinal } from 'utils/date/format.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

import AllServicesDropDown from 'clientCommunications/components/Clients/common/AllServicesDropDown.component';
import AllStylistDropDown from 'clientCommunications/components/Clients/common/AllStylistDropDown.component';
import LastVisit from 'clientCommunications/components/Clients/common/LastVisitDropDown.component';
import Loyalty from 'clientCommunications/components/Clients/common/LoyaltyDropDown';
import NextVisit from 'clientCommunications/components/Clients/common/NextVisitDropDown.component';
import TimeRange from 'clientCommunications/components/Clients/common/TimeRangeDropDown';
const L = logger('ClientFilterBar');

const fromServicesToCount = (services) => {
  const array = [];
  for (const category of services) {
    array.push(category);
    for (const service of category.services) {
      array.push(service);
    }
  }
  return array.length;
};

const formatDisplayDate = (date) => (isDateWorthy(date) ? formatDayToShortYearOrdinal(date) : '');

const getDisplayDateRange = (fromDate, toDate) => `${formatDisplayDate(fromDate)} - ${formatDisplayDate(toDate)}`;

// FIXME: improve all - js css html
class ClientFilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLastVisit: '',
      currentNextVisit: '',
      filterServiceList: [],
      filterStylistList: [],
      totalServicesNumber: fromServicesToCount(this.props.services),
      selectedNoVisit: false,
      selectedWeekAgo: false,
    };
  }

  componentWillUnmount() {
    this.onClearFilters();
  }

  onCheckLatVisit = (option) => void this.setState({ currentLastVisit: option });
  onCheckNoVisit = () => void this.setState({ selectedNoVisit: !this.state.selectedNoVisit });
  onCheckWeekAgo = () => void this.setState({ selectedWeekAgo: !this.state.selectedWeekAgo });
  onCheckNextVisit = (option) => void this.setState({ currentNextVisit: option });

  // FIXME: check if this duplicate or the following one is the correct
  // noinspection JSUnusedGlobalSymbols
  onClearLastVisitSelectionDuplicate = () => {
    this.props.filterLastVisit('');
    this.setState({ currentLastVisit: '' });
  };

  onClearLastVisitSelection = () => {
    this.props.filterLastVisit('');
    this.setState({ currentLastVisit: '' });
    this.openDropDown('lastVisit', true);
  };

  onDoneLastVisit = () => {
    this.props.filterLastVisit(this.state.currentLastVisit);
    this.openDropDown('lastVisit', true);

    this.setState({ currentLastVisit: '' });
    this.props.trackEvent(`lastvisit_${this.state.currentLastVisit}`);
  };

  onClearNextVisitSelection = () => {
    this.props.filterNextVisit('');
    this.setState({ currentNextVisit: '' });
    this.openDropDown('nextVisit', true);
  };

  onDoneLoyalty = (isAnyAmount, amount, isAnyNumber, number) => {
    // Loyalty functionality
    this.props.filterLoyalty(isAnyAmount, amount, isAnyNumber, number);

    this.openDropDown('loyalty', true);
    this.props.trackEvent(`loyalty_${this.state.currentLastVisit}`);
  };

  onDoneNextVisit = () => {
    this.props.filterNextVisit(this.state.currentNextVisit);
    this.openDropDown('nextVisit', true);

    this.setState({ currentNextVisit: '' });
    this.props.trackEvent(`nextvisit_${this.state.currentLastVisit}`);
  };

  onClearFilters = () => {
    this.props.getClientsCalculatedList(this.props.salonId, this.props.bucketType);
    this.setState({ filterStylistList: [] });
    this.setState({ filterServiceList: [] });
    this.setState({ currentNextVisit: '' });
    this.setState({ currentLastVisit: '' });
    this.props.clearLastDatesSelected();
    this.props.trackEvent('clear_filters');
  };

  onDoneSelectTime = () => {
    this.props.filterData(this.props.salonId, this.props.bucketType, this.state.filterStylistList, this.state.filterServiceList);
    setTimeout(() => {
      this.props.filterTimeRange();
    }, 100);
    this.openDropDown('timeRange', true);
  };

  onSelectAllService = (areAllServicesSelected) => {
    const listAll = [];
    if (!areAllServicesSelected) {
      this.props.services.forEach((category) => {
        listAll.push(category);
        category.services.forEach((s) => {
          listAll.push(s);
        });
      });
    }
    this.setState({ filterServiceList: listAll });
    this.props.trackEvent('filter_all_services');
  };

  onSelectServiceItem = (service) => {
    let servicesCategoriesFlatList = this.state.filterServiceList.length < 1 ? [] : [...this.state.filterServiceList];

    const existInList = servicesCategoriesFlatList.filter((c) => c.id === service.id);
    if (existInList.length > 0) {
      servicesCategoriesFlatList = servicesCategoriesFlatList.filter((c) => c.id !== service.id);
      if (service.services) {
        service.services.forEach((s) => {
          servicesCategoriesFlatList = servicesCategoriesFlatList.filter((c) => c.id !== s.id);
        });
      }
    } else {
      servicesCategoriesFlatList.push(service);
      if (service.services) {
        service.services.forEach((selService) => servicesCategoriesFlatList.push(selService));
      }
    }

    this.setState({ filterServiceList: servicesCategoriesFlatList });
    this.props.trackEvent('filter_services');
  };

  onSelectStylist = (stylistId) => {
    let modifiedList = this.state.filterStylistList.length < 1 ? [] : [...this.state.filterStylistList];

    const existInList = modifiedList.filter((c) => c === stylistId);
    if (existInList.length > 0) {
      modifiedList = modifiedList.filter((c) => c !== stylistId);
    } else {
      modifiedList.push(stylistId);
    }

    this.setState({ filterStylistList: modifiedList });
    this.props.trackEvent('filter_stylists');
  };

  onSelectAllStylists = (selectAll) => {
    const listOfAll = [];
    if (selectAll) {
      this.props.stylists.forEach((i) => listOfAll.push(i.id));
    }
    this.setState({ filterStylistList: listOfAll });
    this.props.trackEvent('filter_all_stylists');
  };

  clearLastDatesSelected = () => {
    this.props.clearLastDatesSelected();
    this.openDropDown('timeRange', true);
    this.props.filterData(this.props.salonId, this.props.bucketType, this.state.filterStylistList, this.state.filterServiceList);
  };

  openDropDown = (filter, close) => {
    if (filter !== 'timeRange' && close) {
      this.props.filterData(this.props.salonId, this.props.bucketType, this.state.filterStylistList, this.state.filterServiceList);
    }
    this.props.openDropdown(filter);
  };

  closeFilter = () => {
    if (this.props.isStylistOpen) {
      this.openDropDown('stylist', false);
    } else if (this.props.isServiceOpen) {
      this.openDropDown('service', false);
    } else if (this.props.isLastVisit) {
      this.openDropDown('lastVisit', false);
    } else if (this.props.isNextVisit) {
      this.openDropDown('nextVisit', false);
    } else if (this.props.isTimeRange) {
      this.openDropDown('timeRange', false);
    } else if (this.props.isLoyalty) {
      this.openDropDown('loyalty', false);
    }
  };

  render() {
    const filterStylistList = this.state.filterStylistList;
    const filterServiceList = this.state.filterServiceList;

    const filterStylistListLength = filterStylistList.length;
    const filterServiceListLength = filterServiceList.length;

    const { t, selectedLastVisit, selectedLoyalty, lastDatesSelected, selectedNextVisit, stylists, setTimeRange } = this.props;

    L.debug('render()', { lastDatesSelected });

    const isStylistSelected = filterStylistListLength > 0 && filterStylistListLength !== stylists.length;
    const isStylistAllSelected = filterStylistListLength === stylists.length;

    const selectedStylistLabel = isStylistSelected ? `${filterStylistListLength} ${t('allClients.filterBar.staff')}` : t('allClients.filterBar.staff');
    const stylistLabel = isStylistAllSelected ? t('allClients.filterBar.allStaff') : selectedStylistLabel;

    const selectAll = filterServiceList ? [...filterServiceList] : [];

    const isServiceSelected = filterServiceListLength > 0 && filterServiceListLength !== this.state.totalServicesNumber;
    const isServiceAllSelected = filterServiceListLength === this.state.totalServicesNumber;
    const servicesCount = filterServiceList.filter((c) => !c.services).length;

    const pluralizedServices = servicesCount === 1 ? t('allClients.filterBar.service') : t('allClients.filterBar.services');
    const selectedServiceLabel = isServiceSelected ? `${servicesCount} ${pluralizedServices}` : t('allClients.filterBar.services');
    const serviceLabel = isServiceAllSelected ? t('allClients.filterBar.allServices') : selectedServiceLabel;

    const lastVisitMap = {
      '>7days': t('allClients.filterBar.lastXDays', { days: 7 }),
      noVisit: t('allClients.filterBar.noVisits'),
      '<1year': t('allClients.filterBar.oneYear'),
    };

    const lastVisitClass = selectedLastVisit ? 'selected' : '';
    const lastVisitValue = this.state.currentLastVisit || selectedLastVisit;
    const lastVisitLabel =
      lastVisitMap?.[selectedLastVisit] || parseInt(selectedLastVisit, 10) ? t('allClients.filterBar.greaterThanXWeeks', { weeks: selectedLastVisit }) : t('allClients.filterBar.lastVisit');

    const nextVisitMap = {
      anyDate: t('allClients.filterBar.anyFuture'),
      next7days: t('allClients.filterBar.nextXDays', { days: 7 }),
      noFuture: t('allClients.filterBar.noFuture'),
    };

    const nextVisitClass = selectedNextVisit ? 'selected' : '';
    const nextVisitValue = this.state.currentNextVisit || selectedNextVisit;
    const nextVisitLabel = nextVisitMap?.[selectedNextVisit] || t('allClients.filterBar.nextVisit');

    const timeRangeClass = lastDatesSelected ? 'selected time-range' : '';
    const dateRangeLabel = getDisplayDateRange(lastDatesSelected?.fromDate, lastDatesSelected?.toDate || lastDatesSelected?.fromDate);
    const timeRangeLabel = !lastDatesSelected ? t('allClients.filterBar.dateRange') : dateRangeLabel;

    // gt: '>',
    // lt: '<',
    let loyaltyClass = selectedLoyalty?.isAnyAmount || Boolean(selectedLoyalty?.number) ? 'selected' : '';
    let loyaltyLabel = t('allClients.filterBar.loyalty');
    if (selectedLoyalty) {
      if (selectedLoyalty.isAnyAmount === true) {
        loyaltyLabel = (
          <div>
            {S.gt}
            <CurrencySign />
            {selectedLoyalty.amount.toString()} {t('allClients.filterBar.spend')}
          </div>
        );
      }
      if (selectedLoyalty.number > 0) {
        if (loyaltyLabel === t('allClients.filterBar.loyalty')) {
          loyaltyLabel = (
            <div>
              {S.gt}
              {selectedLoyalty.number.toString()} {t('allClients.filterBar.visits')}
            </div>
          );
        } else if (selectedLoyalty.isAnyAmount === true) {
          loyaltyLabel = t('allClients.filterBar.spendAndVisits');
        }
      }
    }

    const isOverlayVisible = this.props.isStylistOpen || this.props.isServiceOpen || this.props.isLastVisit || this.props.isNextVisit || this.props.isTimeRange || this.props.isLoyalty;

    // TODO: Revisit a11y for the JSX code below
    return (
      <div data-bem="ClientFilterBar" className="client-filter-bar">
        <div className="filter-sub-nav">
          <div className="filter-sub-nav-buttons">
            <div role="button" tabIndex={0} onClick={this.closeFilter} className={`close-filter-overlay ${isOverlayVisible ? 'show' : 'hide'}`} />
            <div className="filter-sub-title">
              <h5 className="main">{t('allClients.filterBar.filters')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('stylist', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isStylistOpen,
                selected: isStylistSelected || isStylistAllSelected,
              })}
            >
              <span className="span-txt">{stylistLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>{t('common.and')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('service', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isServiceOpen,
                selected: isServiceSelected || isServiceAllSelected,
              })}
            >
              <span>{serviceLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>{t('common.and')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('lastVisit', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isLastVisit,
                selected: lastVisitClass,
              })}
            >
              <span>{lastVisitLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>{t('common.and')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('nextVisit', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isNextVisit,
                selected: nextVisitClass,
              })}
            >
              <span>{nextVisitLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>{t('common.and')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('timeRange', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isTimeRange,
                selected: timeRangeClass,
              })}
            >
              <span>{timeRangeLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>{t('common.and')}</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => this.openDropDown('loyalty', false)}
              className={cn({
                filterButton: true,
                opened: this.props.isLoyalty,
                selected: loyaltyClass,
              })}
            >
              <span>{loyaltyLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="clear-filter" role="button" onClick={() => this.onClearFilters()} tabIndex="-1">
              <span>{t('allClients.filterBar.clearFilters')}</span>
            </div>
          </div>
        </div>
        <AllStylistDropDown
          isStylistOpen={this.props.isStylistOpen}
          selectedStylistIds={filterStylistList}
          stylists={stylists}
          onFilterStylist={this.props.filterStylist}
          onSelectStylist={this.onSelectStylist}
          onSelectAllStylists={this.onSelectAllStylists}
          closeStylistDropDown={() => this.openDropDown('stylist', true)}
        />
        <AllServicesDropDown
          services={this.props.services}
          isServiceOpen={this.props.isServiceOpen}
          selectedServices={selectAll}
          filterService={this.props.filterService}
          totalServicesNumber={this.state.totalServicesNumber}
          onSelectAllService={this.onSelectAllService}
          onSelectServiceItem={this.onSelectServiceItem}
          closeServiceDropDown={() => this.openDropDown('service', true)}
        />
        <LastVisit
          isLastVisit={this.props.isLastVisit}
          selectedLastVisit={lastVisitValue}
          selectedNoVisit={this.state.selectedNoVisit}
          selectedWeekAgo={this.state.selectedWeekAgo}
          onClearLastVisitSelection={this.onClearLastVisitSelection}
          onCheckLatVisit={this.onCheckLatVisit}
          onDoneLastVisit={this.onDoneLastVisit}
          onCheckNoVisit={this.onCheckNoVisit}
          onSelectDropdownVisit={alwaysNoop}
          onCheckWeekAgo={this.onCheckWeekAgo}
        />
        <NextVisit
          isNextVisit={this.props.isNextVisit}
          selectedNextVisit={nextVisitValue}
          onCheckNextVisit={this.onCheckNextVisit}
          onClearNextVisitSelection={this.onClearNextVisitSelection}
          onDoneNextVisit={this.onDoneNextVisit}
        />
        <Loyalty isLoyalty={this.props.isLoyalty} selectedLoyalty={this.props.selectedLoyalty} onDoneLoyalty={this.onDoneLoyalty} />
        <TimeRange
          isTimeRange={this.props.isTimeRange}
          onDoneSelectTime={this.onDoneSelectTime}
          setDatePickerDate={setTimeRange}
          clearLastDatesSelected={this.clearLastDatesSelected}
          lastDatesSelected={lastDatesSelected}
        />
      </div>
    );
  }
}

export default withTranslation()(ClientFilterBar);
